export default "__VITE_ASSET__R2oFpRAQ__"